import Api from '@api/xiu_yan/multiStoreApi'
import { SHOP_PRODUCTS_PATH } from '@constant'
import {
  getSessionMerchantInfo,
  isSiDaProperty,
  isUltimate
} from '@merchant-backend/util'
import { getProTitle, logout } from '@util'
import { message, Modal } from 'hljd'
import { action, observable, runInAction } from 'mobx'
import React from 'react'
import { hashHistory } from 'react-router'

class Store {
  @observable sidaVisible = false
  @observable unsidaVisible = false

  @action
  hideModal = type => () => {
    this[type] = false
  }

  @action
  onCancel = () => {
    this.modalIf.isShow = false
  }

  @observable
  modalIf = {
    type: '',
    isShow: false,
    btn1: '',
    btn2: '',
    content: ''
  }

  @action
  checkInfo = () => {
    const title = getProTitle()
    let obj = getSessionMerchantInfo()
    let that = this
    if (
      obj.examine != 1 ||
      ((obj.certify.status != 3 &&
        obj.is_new == 1 &&
        obj.kind != 1 &&
        obj.kind != 2) ||
        (obj.is_opened_trade == false && obj.is_new == '0'))
    ) {
      that.modalIf = {
        type: 1,
        isShow: true,
        btn1: '确定',
        btn2: '',
        content: '您尚未完成店铺审核或实名认证,暂时无法使用此功能！'
      }
      return
    }

    if (!isUltimate()) {
      that.modalIf = {
        type: 2,
        isShow: true,
        btn1: '关闭',
        btn2: `了解${title}`,
        content: `您尚未开通${title}，暂时无法使用此功能！`
      }
      return
    }

    if (isSiDaProperty() || obj.property_id == 15) {
      //老商家并且没有实名认证   可能存在老商家已经强制企业认证了
      if (
        (obj.is_new == 0 && obj.certify.status == 0) ||
        obj.certify.type == 1 ||
        (obj.certify.type == 2 && obj.certify.status != 3)
      ) {
        this.sidaVisible = true
        return false
      }
    } else {
      if (
        (obj.is_new == 0 && obj.certify.status == 0) ||
        obj.certify.type == 1 ||
        (obj.certify.type == 2 && obj.certify.status != 3)
      ) {
        this.unsidaVisible = true
        return false
      }
    }

    this.upgradePro()
  }

  @action
  upgradePro = () => {
    this.sidaVisible = false
    const { can_upgrade } = this
    if (can_upgrade == 1) {
      Modal.confirm({
        title: '升级提示',
        content:
          '升级成功后，当前账号将变为管理员账号，此门店将获得一组新的账号密码，方便您进行多门店登录管理。',
        // onOk(){window.location.href='#/localMerchant/multiStore/upgrade'},
        onOk: () => {
          this.isUpgradeModalShow = true
        },
        onCancel() {},
        cancelText: '下次再说',
        okText: '确认升级',
        iconType: 'info-circle'
      })
    } else {
      Modal.confirm({
        title: '升级失败',
        content: (
          <p>
            您暂未开通<span style={{ color: '#508cee' }}>{getProTitle()}</span>，无法升级多门店系统
          </p>
        ),
        onOk: () => {
          hashHistory.push(SHOP_PRODUCTS_PATH)
        },
        cancelText: '取消',
        okText: `了解${getProTitle()}`,
        iconType: 'exclamation-circle'
      })
    }
  }

  @observable can_upgrade = 0
  @action
  canUpgrade = async () => {
    let {
      data: { can_upgrade }
    } = await Api.canUpgrade()
    runInAction(() => {
      this.can_upgrade = can_upgrade
    })
  }

  /**
   * 父账号升级流程优化 20171204 by xiaoxiong
   */
  @observable isUpgradeModalShow = false
  @observable main_shop_name = ''
  @action
  cancelUpgrade = () => {
    this.isUpgradeModalShow = !this.isUpgradeModalShow
  }

  @action
  resetName = () => {
    this.main_shop_name = ''
  }

  @action
  changeMainShopName = e => {
    this.main_shop_name = e.target.value
  }

  @action
  submitUpgrade = async () => {
    const { success } = await Api.upgradeApi({ name: this.main_shop_name })
    if (success) {
      this.isUpgradeModalShow = false
      message.success('操作成功！2秒后跳转登录页面，请重新登录！')
      setTimeout(() => {
        logout()
      }, 2000)
    }
  }
}
export default new Store()
